import { Selector } from '@ngxs/store';

import { PoiState, PoiStateModel } from './poi.state';
import { PointOfInterest } from '../../core/models';

export class PoiGetterState {
  @Selector([PoiState])
  static getPoiState(state: PoiStateModel): PoiStateModel {
    return state;
  }

  @Selector([PoiState])
  static getPoi(state: PoiStateModel): PointOfInterest[] {
    return state.ids.map(id => state.entities[id]);
  }

  @Selector([PoiState])
  static getloadPoiPostRequestState(state: PoiStateModel) {
    return state.loadPoiPostRequestState;
  }

  @Selector([PoiState])
  static getSavePoiPostRequestState(state: PoiStateModel) {
    return state.savePoiPostRequestState;
  }

  @Selector([PoiState])
  static getDeletePoiPostRequestState(state: PoiStateModel) {
    return state.deletePoiPostRequestState;
  }
}
